import dayjs from "dayjs";

export const catalogId = (value) => value?.id ?? value ?? null;
export const catalogMoney = (value) => value == null || value === "" || !Number.isFinite(Number(value))
  ? "—" : `${Number(value).toLocaleString("fr-FR", { maximumFractionDigits: 2 })} CFA`;

export function formatServiceDuration(value) {
  if (value == null || value === "" || !Number.isFinite(Number(value)) || Number(value) <= 0) return "—";
  const minutes = Math.round(Number(value));
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return hours ? `${hours}h${rest ? ` ${String(rest).padStart(2, "0")} mn` : ""}` : `${rest} mn`;
}

export function appointmentSlot(record) {
  const start = dayjs(record?.starts_at);
  const duration = Number(record?.duration_minutes);
  if (!record?.starts_at || !start.isValid() || !Number.isFinite(duration) || duration <= 0) return "—";
  const end = start.add(duration, "minute");
  return `${start.format("HH:mm")} – ${end.format("HH:mm")}${end.isSame(start, "day") ? "" : " (+1 j)"}`;
}

export function unitEquivalence(unit) {
  if (!unit?.base_unit || !unit.operator || unit.operator_value == null) return "—";
  const factor = Number(unit.operator_value);
  if (!Number.isFinite(factor)) return "—";
  const result = ({ "*": () => factor, "/": () => factor === 0 ? NaN : 1 / factor,
    "+": () => 1 + factor, "-": () => 1 - factor })[unit.operator]?.();
  return Number.isFinite(result)
    ? `1 ${unit.short_name || unit.name || "unité"} = ${result.toLocaleString("fr-FR", { maximumFractionDigits: 8 })} ${unit.base_unit}` : "—";
}

export function preserveSelectedOption(options, value, label) {
  if (value == null || value === "" || options.some((option) => String(option.value) === String(value))) return options;
  return [...options, { value, label: `${label || value} (indisponible)`, disabled: true }];
}

export function requireReference(rows, value, label) {
  if (value && value !== "__global__" && !rows?.some((row) => String(row.id) === String(value))) {
    throw new Error(`${label} n’est plus disponible. Vérifiez votre sélection.`);
  }
}

// Compare the draft and authorised context after a forced reference read.
// A background refresh must never silently replace the user's input.
export async function verifyCatalogDraft(resource, form, contextRef) {
  const context = contextRef.current;
  const draft = JSON.stringify(form.getFieldsValue(true));
  const data = await resource.refresh({ force: true });
  if (context !== contextRef.current || draft !== JSON.stringify(form.getFieldsValue(true))) {
    throw new Error("La saisie ou le contexte a changé pendant la vérification. Vérifiez le formulaire puis réessayez.");
  }
  return data;
}
